import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SpecimenZmInstitutesPage } from '@/features/product/pages/SpecimenZmInstitutesPage';
import { specimenDrillSearchSchema } from '@/features/product/types/product.types';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/product/specimen-distribution/$specimenId/$zmId')({
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: specimenDrillSearchSchema,
  component: function SpecimenZmInstitutesRoute() {
    const { specimenId, zmId } = Route.useParams();
    return (
      <ErrorBoundary moduleName="Specimen Distribution Institutes">
        <Suspense fallback={<PageLoader />}>
          <SpecimenZmInstitutesPage specimenId={specimenId} zmId={zmId} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
